import ForgotPWForm from "./forgottenPassword.view";
import { useNavigate } from "react-router";
import PATHS from "../../../constants/paths";
import * as ProviderService from "../../../services/ProviderService";
import { useTranslation } from "react-i18next";
import showDialog from "../../utils/ShowDialog/ShowDialog";

const LoginContainer = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleOnback = () => {
    navigate(PATHS.EXT_LOGIN);
  };

  const handleSubmit = async (values) => {
    let title = "";
    let text = "";
    let icon = "";
    try {
      const okAction = () => {
        navigate(PATHS.EXT_LOGIN);
      };
      let result = await ProviderService.renewPassword(values);
      if (result) {
        title = t("forms.provider.forgottenPassword.messages.title");
        text = t("forms.provider.forgottenPassword.messages.success");
        icon = "success";
      }
      showDialog(title, text, icon, false, "OK", false, okAction);
    } catch (error) {
      console.log("Error", error);
    }
  };

  return (
    <ForgotPWForm onSubmit={handleSubmit} onBack={handleOnback}></ForgotPWForm>
  );
};

export default LoginContainer;
